module.exports = __webpack_public_path__ + "img/major.88d86eda.png";